export enum CplItemType {
    COMPLIANCE=0,
    REQUEST=1
}